import { YearSegment } from '../types/category';

export const allClassNumbers = Array.from({ length: 9 }, (_, i) => i + 1);

export const getClassFromFirstYear = (firstYear: number): number =>
  getCurrentAcademicYear() - firstYear + 1;

export const getCurrentYearSegment = (): YearSegment => {
  const currentDate = new Date();

  return currentDate.getMonth() > 8 || currentDate.getMonth() < 2
    ? YearSegment.FirstHalf
    : YearSegment.SecondHalf;
};

export const getCurrentAcademicYear = (): number => {
  const currentDate = new Date();

  return currentDate.getMonth() > 8
    ? currentDate.getFullYear()
    : currentDate.getFullYear() - 1;
};
